<div class="sh-list-layout">
  @if (filtersContent) {
    <div id="filters" class="sh-list-layout__filters sh-filters" [class.-sh-collapsed]="filtersCollapsed">
      <div class="sh-filters__collapse-handle">
        <button type="button" (click)="onToggleFilters($event)" class="sh-pure-icon-button -sh-raised" aria-label="angle-double-left">
          <svg sh-icon [name]="'angle-double-left'" [size]="IconSize.SMALL" aria-hidden="true" class="sh-icon-button__icon"></svg>
        </button>
      </div>
      <div class="sh-filters__content">
        <div class="sh-page-section--horizontal sh-page-section--vertical--start">
          <ng-container *ngTemplateOutlet="filtersContent"></ng-container>
        </div>
      </div>
      <div class="sh-filters__content--collapsed">
        <div>
          <ng-container *ngTemplateOutlet="filtersCollapsedContent"></ng-container>
        </div>
      </div>
    </div>
  }
  @if (hierarchyContent) {
    <div id="recordTree" class="sh-list-layout__filters sh-filters" [class.-sh-collapsed]="hierarchyCollapsed">
      <div class="sh-filters__collapse-handle">
        <button type="button" (click)="onToggleRecordTree($event)" class="sh-pure-icon-button -sh-raised" aria-label="angle-double-left">
          <svg sh-icon [name]="'angle-double-left'" [size]="IconSize.SMALL" aria-hidden="true" class="sh-icon-button__icon"></svg>
        </button>
      </div>
      <div class="sh-filters__content">
        <div class="sh-page-section--horizontal sh-page-section--vertical--start">
          <ng-container *ngTemplateOutlet="hierarchyContent"></ng-container>
        </div>
      </div>
      <div class="sh-filters__content--collapsed">
        <div>
          <ng-container *ngTemplateOutlet="hierarchyCollapsedContent"></ng-container>
        </div>
      </div>
    </div>
  }
  <div class="sh-list-layout__list">
    <sh-content-context-notifications-layout>
      <ng-template #content>
        <ng-container *ngTemplateOutlet="mainContent"></ng-container>
      </ng-template>
      <ng-template #context>
        @if (mainContentEmphasisedContext) {
          <div class="-sh-page-section-context-bar--emphasised sh-page-section--horizontal">
            <ng-container *ngTemplateOutlet="mainContentEmphasisedContext"></ng-container>
          </div>
        }
        @if (mainContentContext) {
          <div class="-sh-page-section-context-bar sh-page-section--horizontal">
            <ng-container *ngTemplateOutlet="mainContentContext"></ng-container>
          </div>
        }
      </ng-template>
    </sh-content-context-notifications-layout>
  </div>
  @if (detailContent) {
    <div class="sh-list-layout__detail sh-scroll-container" [class.-sh-collapsed]="detailsCollapsed">
      <ng-container *ngTemplateOutlet="detailContent"></ng-container>
    </div>
  }
</div>
